/**
 * Pauses the SMIL animations of the hero city art, which CSS cannot stop:
 * with reduced motion it stays still, and off screen it costs nothing.
 */
import '../css/hero-city.css';

const reducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' );

document.querySelectorAll( '.r2o-city-art' ).forEach( ( svg ) => {
	let onScreen = true;

	const sync = () => {
		if ( onScreen && ! reducedMotion.matches ) {
			svg.unpauseAnimations();
		} else {
			svg.pauseAnimations();
		}
	};

	new window.IntersectionObserver( ( [ entry ] ) => {
		onScreen = entry.isIntersecting;
		sync();
	} ).observe( svg );

	reducedMotion.addEventListener( 'change', sync );
	sync();
} );
